import type { ActivatedRoute, Router } from '@angular/router';

export function navigateToParentRoute(router: Router, route: ActivatedRoute): Promise<boolean> {
  return router.navigate(['../'], { relativeTo: route });
}
